import axios from "axios";
import { api } from "~/router/apiConfig";

export function show(contractId, typeId, stepTypeId) {
  return axios.post(
    api.path("contractSpendingChart.show", {
      contractId: contractId,
      typeId: typeId
    }),
    { stepTypeId }
  );
}
